import axios from "axios";

export const baseURL = 'https://imprentaapi.sirumatek.com/api/';

export const backendApi = axios.create({baseURL});

backendApi.interceptors.request.use(

    async(config)=>{
        const token =  localStorage.getItem('token');

        if (token) {
            config.headers!['Authorization']='Bearer '+token;
        }
        return config;
    }

);

export default backendApi;
